import axios from 'axios';
import { queryKeys } from '../utils/queryKeys';

export const ORGANIZATION_SETTINGS_KEY = queryKeys.settings.organization;

const DEFAULT_ORG = {
  gymName: 'FORMAPRO',
  address: 'École de Formation',
  phone: 'Téléphone non renseigné',
  email: 'contact@formapro.com',
  website: '',
  currency: 'DA',
  language: 'fr',
  timezone: 'Africa/Algiers',
  logo: null,
};

/** Normalize org fields used across PDFs, header, receipts. */
export function resolveOrganizationBranding(settings) {
  const s = settings || {};
  return {
    gymName: s.gymName || s.name || DEFAULT_ORG.gymName,
    name: s.gymName || s.name || DEFAULT_ORG.gymName,
    address: s.address || DEFAULT_ORG.address,
    phone: s.phone || DEFAULT_ORG.phone,
    email: s.email || DEFAULT_ORG.email,
    website: s.website || '',
    logo: s.logo || null,
    currency: s.currency || DEFAULT_ORG.currency,
    language: s.language || DEFAULT_ORG.language,
    timezone: s.timezone || DEFAULT_ORG.timezone,
    teacherCommissionRate: s.teacherCommissionRate,
    notifications: s.notifications,
    security: s.security,
    businessHours: s.businessHours,
    billing: s.billing,
  };
}

export async function fetchOrganizationSettings() {
  try {
    const { data } = await axios.get('/settings');
    return resolveOrganizationBranding(data);
  } catch {
    return resolveOrganizationBranding(DEFAULT_ORG);
  }
}

export async function saveOrganizationSettings(settings) {
  const { data } = await axios.put('/settings', settings);
  return resolveOrganizationBranding(data);
}

export async function fetchUiPreferences() {
  try {
    const { data } = await axios.get('/settings/ui');
    return {
      language: data?.language || 'fr',
      theme: data?.theme || 'light',
    };
  } catch {
    return { language: 'fr', theme: 'light' };
  }
}

export async function saveUiPreferences(prefs) {
  const { data } = await axios.put('/settings/ui', prefs);
  return data;
}

export async function fetchCertificationSettings() {
  try {
    const { data } = await axios.get('/settings/certifications');
    return {
      templates: Array.isArray(data?.templates) ? data.templates : [],
      activeTemplateId: data?.activeTemplateId || null,
    };
  } catch {
    return { templates: [], activeTemplateId: null };
  }
}

export async function saveCertificationSettings(settings) {
  const { data } = await axios.put('/settings/certifications', settings);
  return data;
}
